const getCVVLengthOfCard = (scheme) => {
  const typeofScheme = typeof scheme
  if (typeofScheme !== 'string') {
    return 3
  }

  // Amex use 4 digits for CVV - ONLY AMEX
  if (
    scheme.toLowerCase() === 'amex' ||
    scheme.toLowerCase() === 'american express'
  ) {
    return 4
  }

  return 3
}

export { getCVVLengthOfCard }
